export default "__VITE_ASSET__Clk2gAQH__"